import { SimpleDialog, YoutubeDialog, WistiaDialog } from 'global/simple-dialog.src';

(function (fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(function () {
    /*********** content dialog *********/
    [].forEach.call(document.querySelectorAll('.dialog-trigger'), function (btnElem) {
        var dialogElem = document.getElementById(btnElem.getAttribute('data-dialog-id')),
            simpleDialog = new SimpleDialog(dialogElem);

        btnElem.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            simpleDialog.show();
        });
    });
    /*********** youtube dialog *********/
    [].forEach.call(document.querySelectorAll('.youtube-trigger'), function (btnElem) {
        var dialogElem = document.getElementById(btnElem.getAttribute('data-dialog-id')),
            youtubeDialog = new YoutubeDialog(dialogElem);

        btnElem.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            youtubeDialog.show();
        });
    });
    /*********** wistia dialog *********/
    [].forEach.call(document.querySelectorAll('.wistia-trigger'), function (btnElem) {
        var dialogElem = document.getElementById(btnElem.getAttribute('data-dialog-id')),
            wistiaDialog = new WistiaDialog(dialogElem);

        btnElem.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            wistiaDialog.show();
        });
    });

    /*********** accordion *********/
    var accordions = document.querySelectorAll('.accordion'),
        details;

    [].forEach.call(accordions, function (accordion) {
        details = accordion.querySelectorAll('details');

        [].forEach.call(details, function (elem) {
            var inner = elem.querySelector('.inner'),
                summary = elem.querySelector('summary');

            summary.addEventListener('click', function (e) {
                e.preventDefault();

                if (elem.getAttribute('open')) {
                    elem.removeAttribute('open');
                    inner.style.display = 'none';
                } else {
                    elem.setAttribute('open', true);
                    inner.style.display = 'block';
                }
            });
        });
    });
});
